import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { SubCategory } from './subCategory.model';

@Injectable({
  providedIn: 'root'
})
export class SubcategoryService {


  constructor(private http: HttpClient, private globle: Globle, private localStorage: LocalStorageService) {
  }

  getAll(categoryId: number, status: number, directCharge: boolean) {
    return this.http.get<SubCategory[]>(this.globle.APIURL + "allsubCategories/" + categoryId + "?status=" + status + "&directCharge=" + directCharge);
  }

  getById(id: number) {
    return this.http.get<SubCategory>(this.globle.APIURL + "subcategory/" + id);
  }

  Create(subCategory: SubCategory) {

    return this.http.post(this.globle.APIURL + "subcategory", subCategory)
  }

  Update(subCategory: SubCategory) {
    return this.http.put(this.globle.APIURL + "subcategory", subCategory)
  }

  upload(formdata: any) {
    return this.http.post<any>(this.globle.APIURL + "subcategory/upload", formdata)
  }

  Delete(subCategoryId: number) {
    return this.http.delete(this.globle.APIURL + "subcategory/" + subCategoryId)
  }
}
